import React, { useEffect, useState } from "react";
import { ReactComponent as ShootingMenu } from "../../Assets/svgs/entireshoot-menu.svg";
import { ReactComponent as CartMenu } from "../../Assets/svgs/cart-menu.svg";
import { ReactComponent as WishlistMenu } from "../../Assets/svgs/wishlist-menu.svg";
import { ReactComponent as MoreInfoMenu } from "../../Assets/svgs/moreinfo-menu.svg";
import { ReactComponent as DeleteMenu } from "../../Assets/svgs/dustbin-icon.svg";
import { ReactComponent as ZoomIcon } from "../../Assets/svgs/zoomimage-menu.svg";
import { ReactComponent as CloseIcon } from "../../Assets/svgs/close-icon-info.svg";
import {
  AddImageToWishlist,
  RemoveImageFromWishlist,
} from "../../../services/WishListImages";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { wishlistDataSelector } from "../../../redux/wishlist";
import { IconButton, Tooltip, Typography } from "@mui/material";
import DeleteConfirmationDialog from "../../Modals/DeleteConfirmationDialog";
import { BASE_IMAGE_URL, ZOOM_IMAGE_URL } from "../../../config/ApiConfig";
import "../../Assets/css/layout.css";
import Loader from "../../Common/Loader";

const StarsImageMenu = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { wishlistData, triggerWishlistRerender, loadingWishlist } =
    useSelector(wishlistDataSelector);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [loaderImage, setLoaderImage] = useState();
  const [isAlreadyWishlisted, setIsAlreadyWishlisted] = useState(false);
  const [showIcon, setShowIcon] = useState({
    showEntireShoot: true,
    showSameModel: false,
    showWishlist: true,
    showDelete: false,
    showInfo: true,
    showClose: false,
  });
  useEffect(() => {
    checkAllWishlist();
  }, [props]);
  useEffect(() => {
    if (triggerWishlistRerender) {
      checkAllWishlist();
    }
  }, [triggerWishlistRerender]);
  useEffect(() => {
    if (props.isWishlistMenu === true) {
      setShowIcon({
        ...showIcon,
        showEntireShoot: false,
        showWishlist: false,
        showDelete: true,
        showInfo: false,
      });
    }
    if (props.isEntireShoot === true) {
      setShowIcon({
        ...showIcon,
        showEntireShoot: false,
      });
    }
    if (props.isInfoPage === true) {
      setShowIcon({
        ...showIcon,
        showInfo: false,
        showClose: true,
      });
    }
  }, [props]);
  const checkAllWishlist = () => {
    if (
      wishlistData &&
      wishlistData?.items &&
      wishlistData?.items?.starDetail?.length > 0
    ) {
      const checkIsAlreadyWishlisted = wishlistData?.items?.starDetail?.some(
        (imageData) => imageData.Name === props.imageName
      );
      if (checkIsAlreadyWishlisted) {
        setIsAlreadyWishlisted(checkIsAlreadyWishlisted);
      } else {
        setIsAlreadyWishlisted(false);
      }
    }
  };
  const handleAddToCart = () => {
    const tokenData = localStorage.getItem("token");
    if (tokenData) {
      window.open(`/stars/starpricing/${props.imageName}`, "_blank");
    } else {
      const afterLoginFunction = {
        type: "navigate",
        to: `/stars/starpricing/${props.imageName}`,
      };
      localStorage.setItem(
        "afterLogin",
        JSON.stringify(afterLoginFunction || {})
      );
      navigate("/signin");
      toast.error(`Please Login First`, {
        autoClose: 2500,
      });
    }
  };
  const handleAddToWishlist = async () => {
    const tokenData = localStorage.getItem("token");
    setLoaderImage(props.imageName);
    if (tokenData) {
      const CustomToastWithLink = () => (
        <Link to="/wishlist">
          <div className="custom-toast-with-icon">
            <WishlistMenu className="custom-toast-icon" />
            <Typography
              variant="mainsectiontitle"
              component="div"
              className="boldFont"
            >
              Go to Wish List
            </Typography>
          </div>
        </Link>
      );
      const dataWithoutAPICall = {
        image_id:
          props.isEntireShoot === true
            ? props?.imageItem?.sno
            : props.isSameModel === true
            ? props?.imageItem?.sno
            : props?.isInfoPage === true
            ? props?.imageSno
            : props?.imageItem?._source?.ImageWebId,
        type: "1",
      };
      const response = await dispatch(AddImageToWishlist(dataWithoutAPICall));
      if (response === true) {
        toast(CustomToastWithLink, { autoClose: 2500 });
      }
      setLoaderImage();
    } else {
      const afterLoginFunction = {
        type: "wishlist",
        data: {
          image_id:
            props.isEntireShoot === true
              ? props?.imageItem?.sno
              : props.isSameModel === true
              ? props?.imageItem?.sno
              : props?.isInfoPage === true
              ? props?.imageSno
              : props?.imageItem?._source?.ImageWebId,
          type: "1",
        },
      };
      localStorage.setItem(
        "afterLogin",
        JSON.stringify(afterLoginFunction || {})
      );
      navigate("/signin");
      toast.error(`Please Login First`, {
        autoClose: 2500,
      });
      setLoaderImage();
    }
  };
  const handleEntireShootImage = (imageId) => {
    const imageData = props?.imageItem?._source?.url?.split("/");
    if (imageId !== undefined) {
      props?.isSameModel === true
        ? window.open(
            `/stars/starsentireshoot/${props?.imageItem?.shootid}`,
            "_blank"
          )
        : props?.isInfoPage === true
        ? window.open(`/stars/starsentireshoot/${props?.shootId}`, "_blank")
        : window.open(`/stars/starsentireshoot/${imageData[0]}`, "_blank");
    }
  };
  const handleCloseConfirmationDialog = () => {
    setOpenConfirmationDialog(false);
  };
  const handleInformationImage = () => {
    localStorage.removeItem("info-image");
    if (props.isEntireShoot === true) {
      const imageInfo = {
        url: `${ZOOM_IMAGE_URL}${props?.imageItem?.shootid}/${props?.imageItem?.Name}.jpg`,
        shootId: props?.imageItem?.shootid,
        rank: props?.imageItem?.rank,
        imageName: props?.imageItem?.Name,
        image_alignment: props?.imageItem?.image_alignment,
        sno: props?.imageItem?.sno,
      };
      localStorage.setItem("info-image", JSON.stringify(imageInfo));
      window.open(`/stars/starsmoreinfo/${props.imageName}`, "_blank");
    }
    if (props.isSameModel === true) {
      const imageInfo = {
        url: `${ZOOM_IMAGE_URL}${props?.imageItem?.shootid}/${props?.imageItem?.Name}.jpg`,
        shootId: props?.imageItem?.shootid,
        rank: props?.imageItem?.rank,
        imageName: props?.imageItem?.Name,
        image_alignment: props?.imageItem?.image_alignment,
        sno: props?.imageItem?.sno,
      };
      localStorage.setItem("info-image", JSON.stringify(imageInfo));
      window.open(`/stars/starsmoreinfo/${props.imageName}`, "_blank");
    }
    if (props.isMainMenu === true) {
      const sourceURL = props?.imageItem?._source?.url?.split("/");
      const imageInfo = {
        url: `${ZOOM_IMAGE_URL}${sourceURL[0]}/${sourceURL[2]}.jpg`,
        shootId: sourceURL[0],
        rank: sourceURL[1],
        imageName: sourceURL[2],
        image_alignment: props?.imageItem?._source?.alignment,
        sno: props?.imageItem?._source?.ImageWebId,
      };
      localStorage.setItem("info-image", JSON.stringify(imageInfo));
      window.open(`/stars/starsmoreinfo/${props.imageName}`, "_blank");
    }
  };
  const handleRemoveWishlistImage = async () => {
    const tokenData = localStorage.getItem("token");
    if (tokenData) {
      setOpenConfirmationDialog(true);
    } else {
      navigate("/signin");
      toast.error(`Please Login First`, {
        autoClose: 2500,
      });
    }
  };
  const handleDelteConfirmation = async () => {
    try {
      const payload = {
        image_id: props?.imageItem?.sno,
      };
      dispatch(RemoveImageFromWishlist(payload));
      setOpenConfirmationDialog(false);
    } catch (e) {
      toast.error(`Something went wrong. Please try again.`, {
        autoClose: 2500,
      });
    }
    setOpenConfirmationDialog(false);
  };
  return (
    <>
      {openConfirmationDialog === true && (
        <DeleteConfirmationDialog
          open={openConfirmationDialog}
          onClose={handleCloseConfirmationDialog}
          imageLink={`${BASE_IMAGE_URL}${props?.imageItem?.shootid}/${props?.imageItem?.rank}-${props?.imageItem?.Name}.jpg`}
          onConfirmation={handleDelteConfirmation}
        />
      )}
      {props.hasImageZoomMenu === true && (
        <div className="image-menu-zoom">
          <IconButton
            className="zoomImageButton"
            onClick={() => props.handleOpenModal()}
          >
            <ZoomIcon className="image-menu-vertical-icon image-menu-icon" />
          </IconButton>
        </div>
      )}
      {props.hasImageCloseMenu === true && (
        <div className="image-menu-zoom">
          <IconButton
            className="zoomImageButton"
            onClick={() => window.close()}
          >
            <CloseIcon className="image-menu-vertical-icon image-menu-icon" />
          </IconButton>
        </div>
      )}
      {props.hasMagnifyButton === true && (
        <div className="image-menu-zoom">
          <Tooltip title="Close Image" arrow placement="top">
            <IconButton
              className="zoomImageButton"
              onClick={() => props.handleOpenMagnifyImage()}
            >
              <ZoomIcon className="image-menu-vertical-icon image-menu-icon" />
            </IconButton>
          </Tooltip>
        </div>
      )}
      <div className="image-menu-main">
        {props.imageAlignment === "V" ? (
          <div className="image-menu-vertical-container">
            <div className="image-menu-name">
              <Typography
                variant="sectiondata"
                className="font-white"
                component="div"
              >
                {props.imageName}
              </Typography>
            </div>
            <div className="image-menu-vertical-items">
              {showIcon.showEntireShoot === true && (
                <Tooltip title="Entire Shoot" arrow placement="top">
                  <IconButton
                    className="ImageMenuButtonVertical"
                    onClick={() => handleEntireShootImage(props.imageName)}
                  >
                    <ShootingMenu className="image-menu-vertical-icon image-menu-icon" />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip title="Add To Cart" arrow placement="top">
                <IconButton
                  className="ImageMenuButtonVertical"
                  onClick={() => handleAddToCart()}
                >
                  <CartMenu className="image-menu-vertical-icon image-menu-icon" />
                </IconButton>
              </Tooltip>

              {showIcon.showWishlist === true && (
                <Tooltip title="Add To Wishlist" arrow placement="top">
                  <IconButton
                    className="ImageMenuButtonVertical"
                    onClick={() => handleAddToWishlist(props.imageName)}
                  >
                    <WishlistMenu
                      className={`${
                        isAlreadyWishlisted === true
                          ? "wishlisted-image-icon"
                          : ""
                      } image-menu-vertical-icon image-menu-icon`}
                    />
                  </IconButton>
                </Tooltip>
              )}
              {showIcon.showDelete === true && (
                <Tooltip title="Remove From Wishlist" arrow placement="top">
                  <IconButton
                    className="ImageMenuButtonVertical"
                    onClick={() => handleRemoveWishlistImage(props.imageName)}
                  >
                    <DeleteMenu className="image-menu-vertical-icon image-menu-icon" />
                  </IconButton>
                </Tooltip>
              )}
              {showIcon.showInfo === true && (
                <Tooltip title="More Info" arrow placement="top">
                  <IconButton
                    className="ImageMenuButtonVertical"
                    onClick={() => handleInformationImage()}
                  >
                    <MoreInfoMenu className="image-menu-vertical-icon image-menu-icon" />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          </div>
        ) : (
          <div className="image-menu-container">
            <div>
              {showIcon.showEntireShoot === true && (
                <Tooltip title="Entire Shoot" arrow placement="top">
                  <IconButton
                    className="ImageMenuButtonHorizontal"
                    onClick={() => handleEntireShootImage(props.imageName)}
                  >
                    <ShootingMenu className="image-menu-horizontal-icon image-menu-icon" />
                  </IconButton>
                </Tooltip>
              )}
            </div>
            <div className="image-menu-name">
              <Typography
                variant="sectiondata"
                className="font-white"
                component="div"
              >
                {props.imageName}
              </Typography>
            </div>
            <div className="image-menu-right-icon">
              <Tooltip title="Add To Cart" arrow placement="top">
                <IconButton
                  className="ImageMenuButtonHorizontal"
                  onClick={() => handleAddToCart()}
                >
                  <CartMenu className="image-menu-horizontal-icon image-menu-icon" />
                </IconButton>
              </Tooltip>
              {showIcon.showWishlist === true && (
                <Tooltip title="Add To Wishlist" arrow placement="top">
                  <IconButton
                    className="ImageMenuButtonHorizontal"
                    onClick={() => handleAddToWishlist(props.imageName)}
                  >
                    <WishlistMenu
                      className={`${
                        isAlreadyWishlisted === true
                          ? "wishlisted-image-icon"
                          : ""
                      } image-menu-horizontal-icon image-menu-icon`}
                    />
                  </IconButton>
                </Tooltip>
              )}
              {showIcon.showDelete === true && (
                <Tooltip title="Remove From Wishlist" arrow placement="top">
                  <IconButton
                    className="ImageMenuButtonHorizontal"
                    onClick={() => handleRemoveWishlistImage(props.imageName)}
                  >
                    <DeleteMenu className="image-menu-horizontal-icon image-menu-icon" />
                  </IconButton>
                </Tooltip>
              )}
              {showIcon.showInfo === true && (
                <Tooltip title="More Info" arrow placement="top">
                  <IconButton
                    className="ImageMenuButtonHorizontal"
                    onClick={() => handleInformationImage()}
                  >
                    <MoreInfoMenu className="image-menu-horizontal-icon image-menu-icon" />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          </div>
        )}
      </div>
      {loaderImage === props.imageName && loadingWishlist && <Loader />}
    </>
  );
};

export default React.memo(StarsImageMenu);

StarsImageMenu.defaultProps = {
  handleOpenModal: () => {},
};
